var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal-filters',{on:{"reset-filters":_vm.reset},scopedSlots:_vm._u([{key:"default",fn:function({ attrs, on }){return [_c('form-builder',_vm._g(_vm._b({ref:"formBuilder",attrs:{"schema":_vm.schema}},'form-builder',attrs,false),on))]}}]),model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }